import { useState, useEffect } from 'react';
import { Table, Tag } from 'antd';
import moment from 'moment';
import { BreathAPIs } from '../../APIs/BreathAPIs';

const PublicSoftwareVersionTable = ({ softwareType, title }) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 5,
    });

    const fetchVersions = async (page = 1, pageSize = 5) => {
        try {
            setIsLoading(true);
            const res = await BreathAPIs.getPublicSoftwareVersionList(softwareType, page, pageSize);
            setData(res.data.softwareVersionList || []);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
            });
        } catch (error) {
            console.error(`Error fetching ${softwareType} version list:`, error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchVersions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [softwareType]);

    const handleTableChange = (paginationConfig) => {
        fetchVersions(paginationConfig.current, paginationConfig.pageSize);
    };

    const columns = [
        {
            title: 'Version',
            dataIndex: 'softwareVersion',
            key: 'softwareVersion',
        },
        {
            title: 'Release Date',
            dataIndex: 'releaseDate',
            key: 'releaseDate',
            render: (releaseDate) => releaseDate ? moment(releaseDate).format('YYYY-MM-DD') : 'N/A',
        },
        // {
        //     title: 'Features',
        //     dataIndex: 'features',
        //     key: 'features',
        //     render: (features) => (features && features.length > 0) ? features.map((f, i) => <Tag key={i}>{f}</Tag>) : 'N/A',
        // },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
    ];

    return (
        <div className="mb-4">
            <h4>{title}</h4>
            <Table
                loading={isLoading}
                dataSource={data}
                columns={columns}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                bordered
                size="middle"
            />
        </div>
    );
};

export default PublicSoftwareVersionTable;
